// import { getApiUrl } from '@/sandbox-utils/apis';

export interface GetUserAssistanceParams {
  id: string;
}

export interface UserAssistanceResponse {
  application_code: string;
  application_version: string;
  deadline: number;
  error_content: string;
  file_name: string;
  file_path: string;
  id: number;
  level_type: string;
  level_name: string;
  level_num: number;
  module_code: string;
  nickname: string;
  resource_path: string;
  scene_path: string;
  schedule_num: number;
  snap_shout_storage_id: string;
  snapshot_hash: string;
  snapshot_path: string;
  space_name: string;
  status: number;
  storage_id: string;
  storage_type: string;
  user_content_qiniu_key: string;
  user_head_img: string;
  user_id: number;
}

export interface GetStorageParams {
  share_info_id: string;
  force: boolean;
}

export interface GetStorageResponse {
  token: string;
}

export interface GetSandboxParams {
  // share_info_id: string;
  token: string;
  pool_name: string;
}

export interface GetSandboxResponse {
  endpoint: string;
  heartbeat_duration: number;
  heartbeat_endpoint: string;
  storage_id: string;
  token: string;
  workdir: string;
}

export interface PostStorageTickParams {
  storageId: string;
}

export interface RevertStorageSandboxParams {
  storageId: string;
  share_info_id: number;
}

function syncFetch(url: string, params: { [key: string]: any }, callback?: Func<any>) {
  const xmlHttp = new XMLHttpRequest();
  const queryStr = Object.keys(params)
    .map((item) => `${item}=${params[item]}`)
    .join('&');
  xmlHttp.open('POST', `${url}?${queryStr}`, false);
  xmlHttp.withCredentials = true;
  xmlHttp.setRequestHeader('Content-Type', 'application/json;charset=utf-8');
  xmlHttp.onreadystatechange = function() {
    if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
      callback?.(xmlHttp.responseText);
    }
  };
  xmlHttp.send();
}

export default {
  getUserAssistance: (
    data: GetUserAssistanceParams
  ): Promise<IResponse<UserAssistanceResponse>> => {
    return window.apis.getUserAssistance({
      params: data
    });
  },
  getStorage: (): Promise<IResponse<GetStorageResponse>> => {
    return window.apis.getStorage();
  },
  postStorageTick: (data: PostStorageTickParams): Promise<IResponse<GetStorageResponse>> => {
    return window.apis.postStorageTick({
      params: data
    });
  },
  revertStorageSandbox: (data: RevertStorageSandboxParams, sync?: boolean) => {
    return window.apis.revertStorageSandbox({
      params: data
    });
  },
  getSandbox: (params: GetSandboxParams): Promise<IResponse<GetSandboxResponse>> =>
    window.apis.getSandbox({ data: params })
};
